import React from 'react';
import styles from './ToggleSwitch.module.css';

const ToggleSwitch = ({ 
  checked = false, 
  onChange, 
  disabled = false, 
  size = 'sm' // 'sm' or 'lg'
}) => {
  const handleToggle = () => {
    if (!disabled && onChange) {
      onChange(!checked);
    }
  };

  const sizeClass = size === 'lg' ? styles.large : styles.small;
  const stateClass = checked ? styles.checked : styles.unchecked;
  const disabledClass = disabled ? styles.disabled : '';

  return (
    <div 
      className={`${styles.toggleSwitch} ${sizeClass} ${stateClass} ${disabledClass}`}
      onClick={handleToggle}
      role="switch"
      aria-checked={checked}
      tabIndex={disabled ? -1 : 0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleToggle();
        }
      }}
    >
      <div className={styles.toggleThumb} />
    </div>
  );
};

export default ToggleSwitch;
